import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { AnalyticsService } from '../../services/gtag.service';
import { User } from '../../entities/user.model';
import { Firestore, doc, updateDoc } from '@angular/fire/firestore';

@Component({
  selector: 'app-audio-setup',
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, TranslateModule],
  templateUrl: './audio-setup.page.html',
  styleUrls: ['./audio-setup.page.scss'],
})
export class AudioSetupPage implements OnInit {
  audioSpeed: 1 | 2 | 3 = 2; // Default to medium speed
  femaleVoice: boolean = true; // Default to female voice
  private currentUser: User | null = null;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private authService: AuthService,
    private userService: UserService,
    private analyticsService: AnalyticsService,
    private firestore: Firestore
  ) {}

  ngOnInit() {
    this.authService.currentUser$.subscribe(user => {
      if (user) {
        this.currentUser = user;
        // Load existing preferences
        this.audioSpeed = user.audioSpeed || 2;
        this.femaleVoice = user.femaleVoice !== undefined ? user.femaleVoice : true;
      }
    });
  }

  onAudioSpeedChange() {
    // Optional: Add preview functionality here
    console.log('Audio speed changed to:', this.audioSpeed);
  }

  onVoiceGenderChange() {
    // Optional: Add preview functionality here
    console.log('Voice gender changed to:', this.femaleVoice ? 'female' : 'male');
  }

  goBack() {
    this.router.navigate(['/settings']);
  }

  getButtonText(): string {
    return this.translate.instant('AUDIO_SETUP.SAVE_SETTINGS');
  }

  async savePreferences() {
    if (!this.currentUser) {
      console.error('No user found');
      return;
    }

    try {
      // Update user preferences in Firestore
      const userDocRef = doc(this.firestore, `users/${this.currentUser.uid}`);
      await updateDoc(userDocRef, {
        audioSpeed: this.audioSpeed,
        femaleVoice: this.femaleVoice
      });

      // Update local user object
      this.currentUser.audioSpeed = this.audioSpeed;
      this.currentUser.femaleVoice = this.femaleVoice;

      // Update the auth service with the new user data
      this.authService.setUser(this.currentUser);

      // Track analytics
      this.analyticsService.trackEvent('audio_preferences', 'save', `speed:${this.audioSpeed}_voice:${this.femaleVoice ? 'female' : 'male'}`);

      console.log('Audio preferences saved successfully');
      
      // Navigate back to settings
      this.router.navigate(['/settings']);
    } catch (error) {
      console.error('Error saving audio preferences:', error);
    }
  }

  getSpeedLabel(speed: 1 | 2 | 3): string {
    switch (speed) {
      case 1:
        return this.translate.instant('AUDIO_SETUP.SLOW');
      case 2:
        return this.translate.instant('AUDIO_SETUP.MEDIUM');
      case 3:
        return this.translate.instant('AUDIO_SETUP.FAST');
      default:
        return this.translate.instant('AUDIO_SETUP.MEDIUM');
    }
  }
}
